import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_VENDORS_ASYNC = createAsyncTypes('FETCH_VENDORS', 'VendorProtection')

export const FETCH_VENDOR_SUMMARY_ASYNC = createAsyncTypes(
  'FETCH_VENDOR_SUMMARY',
  'VendorProtection'
)

export const CREATE_VENDOR_ASYNC = createAsyncTypes('CREATE_VENDOR', 'VendorProtection')

export const IMPORT_VENDORS_ASYNC = createAsyncTypes('IMPORT_VENDORS', 'VendorProtection')

export const REMOVE_VENDORS_ASYNC = createAsyncTypes('REMOVE_VENDORS', 'VendorProtection')

export const RESTORE_VENDORS_ASYNC = createAsyncTypes('RESTORE_VENDORS', 'VendorProtection')

export const START_VENDOR_SYNC_ASYNC = createAsyncTypes('START_VENDOR_SYNC', 'VendorProtection')

export const FETCH_VENDOR_SYNC_STATUS_ASYNC = createAsyncTypes(
  'FETCH_VENDOR_SYNC_STATUS',
  'VendorProtection'
)

export const FETCH_VENDOR_SETTINGS_ASYNC = createAsyncTypes(
  'FETCH_VENDOR_SETTINGS',
  'VendorProtection'
)

export const UPDATE_VENDOR_SETTINGS_ASYNC = createAsyncTypes(
  'UPDATE_VENDOR_SETTINGS',
  'VendorProtection'
)

export const SET_VENDOR_QUERY = 'VendorProtection/SET_VENDOR_QUERY'
export const TOGGLE_VENDOR = 'VendorProtection/TOGGLE_VENDOR'
export const TOGGLE_VENDOR_PAGE = 'VendorProtection/TOGGLE_VENDOR_PAGE'
export const CLEAR_VENDOR_SELECTION = 'VendorProtection/CLEAR_VENDOR_SELECTION'
export const CLEAR_VENDOR_UNDO = 'VendorProtection/CLEAR_VENDOR_UNDO'
export const CLEAR_VENDOR_CREATE_ERROR = 'VendorProtection/CLEAR_VENDOR_CREATE_ERROR'
export const CLEAR_VENDOR_IMPORT = 'VendorProtection/CLEAR_VENDOR_IMPORT'
export const VENDOR_SYNC_POLL_EXHAUSTED = 'VendorProtection/VENDOR_SYNC_POLL_EXHAUSTED'

export const PAGE_SIZE = 25
export const SEARCH_DEBOUNCE_MS = 300

// Sync Now (IC-49626).
export const SYNC_POLL_INTERVAL_MS = 5000
// 3 minutes. A pod killed mid-run leaves the row RUNNING until the service
// reaps it 45 minutes later, so the page stops asking on its own.
export const SYNC_POLL_ATTEMPTS = 36

// PARTIAL cannot happen here, but it is in the enum the service returns.
const SYNC_TERMINAL_STATUSES = ['SUCCESS', 'PARTIAL', 'FAILED']

export const isTerminalSyncStatus = (status) => SYNC_TERMINAL_STATUSES.includes(status)

export const DEFAULT_QUERY = {
  search: '',
  authStatus: 'all',
  sort: 'DEFAULT',
  order: 'desc',
  window: '30d',
  page: 1,
}

// Toolbar buckets over the API's four values; `all` is omitted.
export const AUTH_FILTER_TO_STATUSES = {
  pass: ['VERIFIED'],
  partial: ['PARTIAL', 'WARNING'],
  fail: ['FAILED'],
}
